var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subtitle"},[_c('v-toolbar',{attrs:{"color":"light-blue darken-4","dark":"","dense":""}},[_c('v-toolbar-title',[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }